module.exports = __webpack_public_path__ + "img/9791159923296.072c8328.jpg";